// extracted by mini-css-extract-plugin
export var img = "img-module--img--3e6c9";